<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_dict_type') || '字典类型'"
            prop="dictType"
          >
            <el-input
              clearable
              v-model="formData.dictType"
              :placeholder="$l('form_label_pe_dict_type') || '请输入字典类型'"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_dict_value') || '内码值'"
            prop="dictValue"
          >
            <el-input
              clearable
              v-model="formData.dictValue"
              :placeholder="$l('form_label_pe_dict_value') || '请输入内码值'"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_dict_text') || '中文显示文字'"
            prop="dictText"
          >
            <el-input
              clearable
              v-model="formData.dictText"
              :placeholder="
                $l('form_label_pe_dict_text') || '请输入中文显示文字'
              "
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('form_label_dict_text_en') || '英文显示文字'"
            prop="dictTextEn"
          >
            <el-input
              clearable
              v-model="formData.dictTextEn"
              :placeholder="
                $l('form_label_pe_dict_text_en') || '请输入英文显示文字'
              "
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }">
          <el-form-item
            :label="$l('form_label_dict_description') || '字典说明'"
            prop="dictDescription"
          >
            <el-input
              clearable
              v-model="formData.dictDescription"
              :placeholder="
                $l('form_label_pe_dict_description') || '请输入字典说明'
              "
              type="textarea"
              rows="3"
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('table_label_dict_status') || '有效状态'"
            prop="dictStatus"
          >
            <br />
            <el-radio-group v-model="formData.dictStatus" :disabled="true">
              <el-radio label="Y">{{
                $l('INDEX.form_label_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('INDEX.form_label_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 6 }" :lg="{ span: 12 }">
          <el-form-item
            :label="$l('table_label_system_use') || '是否系统使用'"
            prop="isSystemUse"
          >
            <br />
            <el-radio-group v-model="formData.isSystemUse">
              <el-radio label="Y">{{ $l('INDEX.YES') || '是' }}</el-radio>
              <el-radio label="N">{{ $l('INDEX.NO') || '否' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    keyID: String,
    params: { type: Object, default: () => {} }
  },
  data() {
    return {
      formData: { dictStatus: 'Y', isSystemUse: 'Y' },
      rules: {
        dictType: [
          {
            required: true,
            message: this.$l('form_label_pe_dict_type') || '请输入字典类型',
            trigger: 'blur'
          }
        ],
        dictValue: [
          {
            required: true,
            message: this.$l('form_label_pe_dict_value') || '请输入内码值',
            trigger: 'blur'
          }
        ],
        dictText: [
          {
            required: true,
            message: this.$l('form_label_pe_dict_text') || '请输入中文显示文字',
            trigger: 'blur'
          }
        ],
        dictTextEn: [
          {
            required: true,
            message:
              this.$l('form_label_pe_dict_text_en') || '请输入英文显示文字',
            trigger: 'blur'
          }
        ],
        dictDescription: [
          {
            required: true,
            message:
              this.$l('form_label_pe_dict_description') || '请输入字典说明',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.keyID) return

      this.$api
        .systemDictionaryDetailApi({
          keyID: this.keyID
        })
        .then((res) => {
          console.log(res.body)
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .systemDictionarySaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
